{
  "duration-form": {
    "text": {
      "hour": "Hour",
      "minute": "Minute"
    }
  }
}
